import React, { Fragment } from "react";
import "echarts/lib/chart/gauge";
import ReactEchartsCore from "echarts-for-react/lib/core";
import * as echarts from "echarts/core";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/title";
import "echarts/lib/component/legend";
import { Tag } from "antd";
import styles from "../dashboard.module.scss";

interface Iguage {
  title: string;
  GuageName: string;
  value: number;
  unit: string;
  max?: number;
  min?: number;
  c1?: number;
  c2?: number;
  c3?: number;
  c4?: number;
}

const CheckColor = (title: string) => {
  switch (title) {
    case "Battery":
      return <Tag color="#108ee9">Battery</Tag>;
    case "Pannel":
      return <Tag color="#87d068">Pannel</Tag>;
    case "Load":
      return <Tag color="#f50">Load</Tag>;
  }
};

export const DashboardIoTGuageC: React.FC<Iguage> = ({ title, GuageName, value, unit, max, min, c1, c2, c3, c4 }) => {
  const getOption = () => {
    const option = {
      // tooltip: {
      //   formatter: "{a} <br/>{b} : {c}%",
      // },
      toolbox: {
        feature: {
          // restore: {},
          // saveAsImage: {},
        },
      },
      series: [
        {
          name: "IoT",
          type: "gauge",
          min: min,
          max: max,
          precision: 0,
          splitNumber: 4,
          radius: "80%",
          detail: {
            formatter: `{value}${unit}`,
            fontSize: 20,
            fontWeight: "bold",
            offsetCenter: [0, "70%"],
            color: !value ? "#00BBFF" : "auto",
          },
          data: [
            {
              value: value,
              name: GuageName,
            },
          ],
          axisLine: {
            roundCap: false,
            lineStyle: {
              width: 25,
              color: [
                [c1, "#00BBFF"],
                [c2, "#32CD32"],
                [c3, "#FFCC22"],
                [c4, "#FF4500"],
              ],
            },
          },
          axisTick: {
            show: false,
            splitNumber: 1,
            lineStyle: {
              width: 2,
              color: "auto",
            },
          },
          axisLabel: {
            distance: 20, // 刻度距離 chart 的距離
            textStyle: {
              color: "#666666",
              fontWeight: "bold",
              fontSize: 14,
            },
          },
          splitLine: {
            show: false,
            // 分隔线
            length: 10, // 属性length控制线长
            lineStyle: {
              // 属性lineStyle（详见lineStyle）控制线条样式
              color: "auto",
            },
          },
          pointer: {
            width: 8,
            length: "70%",
            itemStyle: {
              color: !value ? "#00BBFF" : "auto",
            },
          },
          title: {
            show: false,
          },
        },
      ],
    };
    return option;
  };

  return (
    <Fragment>
      <ReactEchartsCore
        echarts={echarts}
        option={getOption()}
        notMerge={true}
        lazyUpdate={false}
        theme={"theme_name"}
        className={styles.guage}
      />

      <div className={styles.guageTag}>
        {CheckColor(title)} <p>{GuageName}</p>
      </div>
    </Fragment>
  );
};

export const DashboardIoTOneShot: React.FC<Iguage> = ({ title, GuageName, value, unit }) => {
  const getOption = () => {
    const option = {
      series: [
        {
          name: "IoT",
          type: "gauge",
          // min: 0,
          // max: 270,
          startAngle: 90,
          endAngle: -269.9,
          splitNumber: 0,
          detail: { formatter: `{value}${unit}`, fontSize: 20, color: "auto" },
          data: [{ value: value, name: GuageName }],
          axisLine: {
            roundCap: false,
            lineStyle: {
              width: 15,
              color: [[1, "rgb(0, 148, 206)"]],
            },
          },
          axisLabel: {
            distance: 10,
            color: "transparent",
          },
          splitLine: {
            show: false,
            // 分隔线
            length: 10, // 属性length控制线长
            lineStyle: {
              // 属性lineStyle（详见lineStyle）控制线条样式
              color: "auto",
            },
          },
          pointer: {
            width: 2,
            length: "65%",
            itemStyle: {
              color: "auto",
            },
          },
          title: {
            show: false,
          },
        },
      ],
    };
    return option;
  };

  return (
    <Fragment>
      <ReactEchartsCore
        echarts={echarts}
        option={getOption()}
        notMerge={true}
        lazyUpdate={true}
        theme={"theme_name"}
        className={styles.guage}
      />

      <div className={styles.guageTag}>
        {CheckColor(title)} <p>{GuageName}</p>
      </div>
    </Fragment>
  );
};

export const DashboardIoTExtreme: React.FC<Iguage> = ({ title, GuageName, value, unit, max, min }) => {
  const getOption = () => {
    const option = {
      series: [
        {
          name: "IoT",
          type: "gauge",
          min: min,
          max: max,
          startAngle: 200,
          endAngle: -20,
          splitNumber: 1,
          radius: "80%", // 圖示放大縮小
          detail: { formatter: `{value}${unit}`, fontSize: 20, color: "auto" },
          data: [{ value: value, name: GuageName }],
          //     progress: {
          //       show: true,
          //       roundCap: true,
          //       width: 18
          //   },
          //   itemStyle: {
          //     color: '#58D9F9',
          //     shadowColor: 'rgba(0,138,255,0.45)',
          //     shadowBlur: 10,
          //     shadowOffsetX: 2,
          //     shadowOffsetY: 2
          // },
          axisLine: {
            roundCap: false,
            lineStyle: {
              width: 20,
              color: [[1, "#556B2F"]],
            },
          },
          axisTick: {
            show: false,
            splitNumber: 5,
            length: 5,
            lineStyle: {
              width: 1,
              color: "#fff",
            },
          },
          splitLine: {
            show: true,
            // 分隔线
            length: 28, // 属性length控制线长
            lineStyle: {
              // 属性lineStyle（详见lineStyle）控制线条样式
              width: 1,
              color: "#fff",
              opacity: "0%",
            },
          },
          pointer: {
            width: 8,
            length: "70%",
            itemStyle: {
              color: "auto",
            },
          },
          axisLabel: {
            distance: 5,
            color: "#666666",
            fontWeight: "bold",
            fontSize: 14,
          },
          title: {
            show: false,
          },
        },
      ],
    };
    return option;
  };

  return (
    <Fragment>
      <ReactEchartsCore
        echarts={echarts}
        option={getOption()}
        notMerge={true}
        lazyUpdate={true}
        theme={"theme_name"}
        className={styles.guage}
        // onChartReady={onChartReadyCallback()} // optional
        // onEvents={EventsDict} // optional
        // opts={} // optional
      />

      <div className={styles.guageTag_upper}>
        {CheckColor(title)} <p>{GuageName}</p>
      </div>
    </Fragment>
  );
};

export const DashboardIoTExtremeWide: React.FC<Iguage> = ({
  title,
  GuageName,
  value,
  unit,
  max,
  min,
  c1,
  c2,
  c3,
  c4,
}) => {
  const getOption = () => {
    const option = {
      series: [
        {
          name: "IoT",
          type: "gauge",
          min: min,
          max: max,
          startAngle: 200,
          endAngle: -20,
          splitNumber: 5,
          radius: "85%",
          detail: {
            formatter: `{value} ${unit}`,
            fontSize: 18,
            fontWeight: "bold",
            color: !value ? "#20B2AA" : "auto",
          },
          data: [{ value: value, name: GuageName }],
          //     progress: {
          //       show: true,
          //       roundCap: true,
          //       width: 18
          //   },
          //   itemStyle: {
          //     color: '#58D9F9',
          //     shadowColor: 'rgba(0,138,255,0.45)',
          //     shadowBlur: 10,
          //     shadowOffsetX: 2,
          //     shadowOffsetY: 2
          // },
          axisLine: {
            roundCap: false,
            lineStyle: {
              width: 20,
              color: [
                [c1, "#20B2AA"],
                [c2, "#20B2AA"],
                [c3, "#008080"],
                [c4, "#008080"],
              ],
            },
          },
          axisTick: {
            // 刻度
            show: true,
            splitNumber: 5,
            length: 5,
            distance: 5,
            lineStyle: {
              width: 1,
              color: "#63677A",
              opacity: 1,
            },
          },
          splitLine: {
            // 分隔线
            show: true,
            length: 10, // 属性length控制线长
            distance: 5,
            lineStyle: {
              // 属性lineStyle（详见lineStyle）控制线条样式
              width: 1,
              color: "#63677A",
              opacity: 1,
            },
          },
          pointer: {
            width: 8,
            length: "70%",
            itemStyle: {
              color: !value ? "#20B2AA" : "auto",
            },
          },
          axisLabel: {
            distance: 28,
            color: "#666666",
            fontWeight: "bold",
            fontSize: 14,
          },
          title: {
            show: false,
            // offsetCenter: ["0%", "45%"],
          },
        },
      ],
    };
    return option;
  };

  return (
    <Fragment>
      <ReactEchartsCore
        echarts={echarts}
        option={getOption()}
        notMerge={true}
        lazyUpdate={false}
        theme={"theme_name"}
        className={styles.guage}
        // onChartReady={this.onChartReadyCallback}
        // onEvents={EventsDict}
        // opts={}
      />

      <div className={styles.guageTag_upper}>
        {CheckColor(title)} <p>{GuageName}</p>
      </div>
    </Fragment>
  );
};
